import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Service Type Name',
    field: 'serviceTypeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    searchable: true,
  },
];
